module.exports = __webpack_public_path__ + "img/akwaeke-emezi.6d627c59.png";